import { defaultApiInstance } from '@/compositions/api';

export function setBooking(data) {
  return defaultApiInstance.post(`v1/booking/`, JSON.stringify(data));
}

export function cancelBooking(data) {
  return defaultApiInstance.post(`v1/booking/return`, JSON.stringify(data));
}
